angular.module("vgresiduos").factory("userService", [
	"$http",
	"accountService",
	function ($http, accountService) {
		"use strict";

		function getBaseCoreRequestUrl() {
			const organizationId = accountService.getCurrentClient().organization.id;

			return Vgr.constants.coreHostUrl + Vgr.resources.core.organizationUsers.replace("[ORGANIZATION]", organizationId);
		}

		const _listUsersV2 = function (dto) {
			const parameters = Vgr.util.serializeObjectToQueryString(dto);

			const req = {
				method: "get",
				url: getBaseCoreRequestUrl() + parameters
			};
			return $http(req);
		};

		return {
			listUsersV2: _listUsersV2
		};
	}
]);
